import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Redirect, Route, Switch } from 'react-router-dom';

import AuthRoute from '../components/auth-route';
import Consent from '../containers/consent';
import E404 from '../containers/e-404';
import Login from '../containers/login';
import TokenDemo from '../containers/token-demo';

class AppRoutes extends React.Component<any, any> {
  public render() {
    return (
      <div>
        <Switch>
          <Route exact={true} path='/' component={E404} />
          <Route path='/interaction/:grant/login' component={Login} />
          <AuthRoute path='/interaction/:grant/confirm' redirectTo='/interaction/:grant/login' component={Consent}/>
          <Route path='/demo/implicit/callback' component={TokenDemo} />
          <Redirect to='/' />
        </Switch>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return { ...state };
}

export default withRouter(connect(
  mapStateToProps
)(AppRoutes));




// WEBPACK FOOTER //
// ./src/routes/index.tsx